'use strict';
var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault');
Object.defineProperty(exports, '__esModule', {
    value: true
});
exports.PositionHandler = PositionHandler;
var _defineProperty2 = _interopRequireDefault(require('@babel/runtime/helpers/defineProperty'));
var _react = _interopRequireDefault(require('react'));
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    var _arguments = arguments, _loop = function(i) {
        var source = _arguments[i] != null ? _arguments[i] : {
        };
        if (i % 2) {
            ownKeys(Object(source), true).forEach(function(key) {
                (0, _defineProperty2.default)(target, key, source[key]);
            });
        } else if (Object.getOwnPropertyDescriptors) {
            Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
            ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
    };
    for(var i = 1; i < arguments.length; i++)_loop(i);
    return target;
}
function PositionHandler(param) {
    var positionStyle = param.positionStyle, children = param.children, instance = param.instance;
    var fixedWidth = instance && instance.fixedWrapperStyle && instance.fixedWrapperStyle.width;
    var fixedHeight = instance && instance.fixedWrapperStyle && instance.fixedWrapperStyle.height;
    var commonWidth = instance && instance.commonStyle && instance.commonStyle.width;
    var styleOBj = _objectSpread(_objectSpread({
    }, positionStyle), {
    }, {
        width: fixedWidth || (commonWidth ? 'auto' : '100%'),
        height: fixedHeight || 'auto',
        zIndex: 999
    });
    return(/*#__PURE__*/ _react.default.createElement('div', {
        style: styleOBj
    }, children));
}
